import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as axios from 'axios';
import { asyncLocalStorage, locale } from '..';
var userSessionName = 'user_session';
var AXIOS = axios.default.create({
  timeout: 10000
});
AXIOS.interceptors.request.use(function (config) {
  return __awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var token, lang;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return asyncLocalStorage().getItem(userSessionName);

          case 2:
            token = _context.sent;
            lang = locale();
            config.params = config.params || {};
            config.params['lang'] = lang;

            if (!token) {
              _context.next = 11;
              break;
            }

            config.headers.Authorization = "Bearer ".concat(token);
            return _context.abrupt("return", config);

          case 11:
            return _context.abrupt("return", config);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
AXIOS.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return __awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(error.response && error.response.status === 401)) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return asyncLocalStorage().removeItem(userSessionName);

          case 3:
            return _context2.abrupt("return", Promise.reject(error));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
});
export default AXIOS;